import type { TagType } from './LinearTag';
import type { CountryCode, LanguageCode } from '@Types/Base';
import type { ExtraDiscountTagData } from '@Types/Product';

interface TagData extends ExtraDiscountTagData {
  icon: 'fire' | 'party' | 'plus';
}

type TagsData = Partial<Record<TagType, TagData>>;
type LocalData = Partial<Record<LanguageCode, TagsData>>;

//TODO: В планах отказаться от этого файла и перенести логику тега в админку.

const tags: Partial<Record<CountryCode, LocalData>> = {
  RUS: {
    ru: {
      kits: {
        icon: 'plus',
        color: '#F0E5CF',
        text1: 'Вместе дешевле',
        text2: 'Кровать + Матрас',
      },
    },
  },
  BLR: {
    ru: {
      kits: {
        icon: 'plus',
        color: '#F0E5CF',
        text1: 'Вместе дешевле',
        text2: 'Кровать + Матрас',
      },
    },
  },
};

export default tags;
